import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useScrollStore = defineStore('scroll', () => {

	const header = ref(null);
	const headerFixed = ref(false);

	const headerHeight =  computed(() => header.value?.offsetHeight);

	const handleScroll = () => {
		headerFixed.value =  window.scrollY > headerHeight.value;
	}

    return {
		handleScroll,

		header,
		headerHeight,
		headerFixed,
	}
})
